import {
  AfterContentInit,
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  PLATFORM_ID,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SdTabComponent } from '../tab/tab.component';
import { isPlatformBrowser, NgClass, NgTemplateOutlet } from '@angular/common';
import { TabGroupLayoutEnum } from '../../../_enums/tab-group.enum';
import { AnimationsEnum } from '../../../_enums/animations.enum';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { SdLibConfig } from '../../../sd-lib-config';
import { SdListComponent } from '../../lists/list/list.component';

@Component({
  selector: 'sd-tab-group',
  templateUrl: './tab-group.component.html',
  standalone: true,
  imports: [SdListComponent, NgClass, NgTemplateOutlet]
})
export class SdTabGroupComponent implements AfterContentInit, OnDestroy, AfterViewChecked, OnChanges {
  @Input()
  brand: BrandsEnum;

  @Input()
  selectedTabIndex = 0;

  @Input()
  layout: TabGroupLayoutEnum = TabGroupLayoutEnum.default;

  @ContentChildren(SdTabComponent)
  tabs: QueryList<SdTabComponent>;

  @Output()
  selectedTabIndexChange = new EventEmitter<number>();

  @ViewChild('activeBar', { read: ElementRef })
  activeBar: ElementRef;

  @ViewChild('tabsContainer', { read: ElementRef })
  tabsContainer: ElementRef;

  @ViewChildren('tabList')
  tabList: QueryList<ElementRef>;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.animation ? 'is-animation-' + this.animation : '',
      this.layout === this.tabGroupLayoutEnum.filled
        ? 'is-filled'
        : this.layout === this.tabGroupLayoutEnum.buttons
          ? 'is-button'
          : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  tabSelected: HTMLElement;
  allTabs: SdTabComponent[] = [];
  animation: AnimationsEnum;
  animationEnum = AnimationsEnum;
  changesTabsSubscription: Subscription;
  tabGroupLayoutEnum = TabGroupLayoutEnum;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private el: ElementRef,
    private sdLibConfig: SdLibConfig,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
  ) {
    this.animation = this.sdLibConfig.get().animation;
  }

  ngAfterContentInit() {
    this.allTabs = this.tabs.toArray();
    this.changesTabsSubscription = this.tabs.changes.subscribe((tabs) => {
      this.allTabs = tabs.toArray();
    });
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId)) {
      this.centerSelectedTab();

      if (
        this.animation === AnimationsEnum.slide &&
        this.layout === this.tabGroupLayoutEnum.default
      ) {
        setTimeout(() => {
          this.renderer.setStyle(this.activeBar?.nativeElement, 'opacity', 1);
          this.activeBarPosition();
        });
      }
    }
  }

  ngOnChanges() {
    this.animation = this.sdLibConfig.get(this.brand).animation;
  }

  ngOnDestroy() {
    this.changesTabsSubscription?.unsubscribe();
  }

  selectTab(selectedTab: SdTabComponent) {
    if (!selectedTab.disabled) {
      this.selectedTabIndex = this.allTabs.indexOf(selectedTab);
      this.centerSelectedTab();
      this.selectedTabIndexChange.emit(this.selectedTabIndex);
      if (this.animation === AnimationsEnum.slide) {
        this.activeBarPosition();
      }
    }
  }

  centerSelectedTab() {
    this.tabsContainer?.nativeElement.scrollTo({
      left:
        this.tabList?.toArray()[this.selectedTabIndex]?.nativeElement
          .offsetLeft - 20,
      behavior: 'smooth'
    });
  }

  activeBarPosition() {
    this.tabSelected =
      this.tabList?.toArray()[this.selectedTabIndex]?.nativeElement;
    this.cdRef.markForCheck();
    if (this.tabSelected) {
      this.renderer.setStyle(
        this.activeBar?.nativeElement,
        'width',
        this.tabSelected.offsetWidth + 'px',
      );
      this.renderer.setStyle(
        this.activeBar?.nativeElement,
        'left',
        this.tabSelected.offsetLeft + 'px',
      );
    }
    this.renderer.setStyle(this.activeBar?.nativeElement, 'opacity', 1);
  }
}
